import "./CapabilityStatus.css";

export const CAPABILITY_STATUS = {
  live: { label: "Live", copy: "Built, connected and working end-to-end now." },
  workflow_ready: { label: "Workflow Ready", copy: "Usable in LincWerks now, with one or more steps still handled manually." },
  not_connected: { label: "Not Connected", copy: "The LincWerks side exists, but an external provider, service or data source is not connected yet." },
  in_development: { label: "In Development", copy: "Actively being built or partially implemented; not ready for normal use yet." },
  planned: { label: "Planned", copy: "Accepted into the architecture or roadmap, but development has not started yet." },
};

const ALIASES = {
  live: "live",
  configured: "live",
  internal: "live",
  available: "live",
  current: "in_development",
  workflow_ready: "workflow_ready",
  "workflow-ready": "workflow_ready",
  manual: "workflow_ready",
  not_connected: "not_connected",
  "not-connected": "not_connected",
  in_development: "in_development",
  "in-development": "in_development",
  prototype: "in_development",
  building: "in_development",
  roadmap: "planned",
  next: "planned",
  planned: "planned",
};

export function normalizeCapabilityStatus(status) {
  return ALIASES[String(status || "").toLowerCase()] || "planned";
}

export function CapabilityStatus({ status, withCopy = false, compact = false, className = "" }) {
  const key = normalizeCapabilityStatus(status);
  const item = CAPABILITY_STATUS[key];
  return (
    <span className={`cap-status cap-${key}${compact ? " compact" : ""}${className ? ` ${className}` : ""}`} title={item.copy}>
      <span className="cap-status-dot" />
      <span className="cap-status-label">{item.label}</span>
      {withCopy ? <small>{item.copy}</small> : null}
    </span>
  );
}
